module.exports = __webpack_public_path__ + "img/20220331_102045.b692f247.jpg";